let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iU6G0")).then(() => parcelRequire('byyT7'));